export const formatIBAN = (value: string): string => {
	const clean = (value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()

	// FI + 16 digits formatting: "FI## #### #### #### ##"
	if (clean.length >= 2 && clean.startsWith('FI')) {
		const countryCode = clean.slice(0, 2)
		const digits = clean.slice(2)
		let formatted = countryCode
		for (let i = 0; i < digits.length; i += 4) {
			formatted += ' ' + digits.slice(i, i + 4)
		}
		return formatted.trim()
	}

	// Fallback: add spaces every 4 chars
	let formatted = ''
	for (let i = 0; i < clean.length; i += 4) {
		formatted += (i > 0 ? ' ' : '') + clean.slice(i, i + 4)
	}
	return formatted
}

export const cleanIBAN = (value: string): string => {
	return (value || '').replace(/\s/g, '').toUpperCase()
}
